import { call } from '../xmAPI';

const URI = '/webapi/xm/1/event-filters';

export const LOAD = 'eventFilters/LOAD';
export const LOAD_START = `${LOAD}_START`;
export const LOAD_SUCCESS = `${LOAD}_SUCCESS`;
export const LOAD_FAIL = `${LOAD}_FAIL`;

const defaultParams = {
  offset: 0,
  limit: 100,
  include: 'lastSuppressionDate',
};

export function load(params) {
  return {
    type: LOAD,
    payload: { ...params },
    meta: {
      xmApi: true,
      method: 'get',
      uri: URI,
      params: {
        ...defaultParams,
        ...params,
      },
    },
  };
}

export const LOAD_MORE = 'eventFilters/LOAD_MORE';
export const LOAD_MORE_START = `${LOAD_MORE}_START`;
export const LOAD_MORE_SUCCESS = `${LOAD_MORE}_SUCCESS`;
export const LOAD_MORE_FAIL = `${LOAD_MORE}_FAIL`;

export const loadMore = ({ uri }) => ({
  type: LOAD_MORE,
  payload: {},
  meta: {
    xmApi: true,
    method: 'get',
    uri,
  },
});

export const TOGGLE_ENABLE_DISABLE = 'eventFilters/TOGGLE_ENABLE_DISABLE';
export const TOGGLE_ENABLE_DISABLE_START = `${TOGGLE_ENABLE_DISABLE}_START`;
export const TOGGLE_ENABLE_DISABLE_SUCCESS = `${TOGGLE_ENABLE_DISABLE}_SUCCESS`;
export const TOGGLE_ENABLE_DISABLE_FAIL = `${TOGGLE_ENABLE_DISABLE}_FAIL`;

export const toggleEnableDisable = ({ filterId, active }) => ({
  type: TOGGLE_ENABLE_DISABLE,
  meta: {
    xmApi: true,
    method: 'post',
    uri: URI,
    params: {
      id: filterId,
      active,
      eventFilterType: 'FLOOD_CONTROL',
    },
  },
});

export const SELECT_ROW = 'eventFilters/SELECT_ROW';

export const selectRow = ({ id }) => ({
  type: SELECT_ROW,
  payload: { id },
});

export const UNSELECT_ROWS = 'eventFilters/UNSELECT_ROWS';

export const unselectRows = () => ({
  type: UNSELECT_ROWS,
});

export const DELETE_FILTERS = 'eventFilters/DELETE_FILTERS';
export const DELETE_FILTERS_START = `${DELETE_FILTERS}_START`;
export const DELETE_FILTERS_SUCCESS = `${DELETE_FILTERS}_SUCCESS`;
export const DELETE_FILTERS_FAIL = `${DELETE_FILTERS}_FAIL`;

export const deleteFilters = filterIds => dispatch => {
  dispatch({
    type: DELETE_FILTERS_START,
  });

  return Promise.all(
    filterIds.map(id =>
      call(`${URI}/${id}`, {
        method: 'DELETE',
      }),
    ),
  )
    .then(() => {
      dispatch({
        type: DELETE_FILTERS_SUCCESS,
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_FILTERS_FAIL,
        payload: {
          err,
        },
      });
    });
};
